const setSizeToImgSrc = (src, width) => {
  return src + (src.includes('?v=') ? '&' : '?') + `width=${width}`
}

export default setSizeToImgSrc
